var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container", style: _vm.minHeight }, [
    _c(
      "div",
      {
        staticStyle: {
          width: "100%",
          margin: "0 auto",
          overflow: "hidden",
          position: "relative",
          height: "100%",
        },
      },
      _vm._l(_vm.cachedIframes, function (item) {
        return _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activePath === item.path,
                expression: "activePath === item.path",
              },
            ],
            key: item.path,
            staticClass: "iframe-wrapper",
          },
          [
            _c("iframe", {
              ref: function (el) {
                return _vm.setIframeRef(item.path, el)
              },
              refInFor: true,
              staticStyle: { width: "100%", height: "100%", border: "none" },
              attrs: {
                src: item.iframeUrl,
                frameborder: "0",
                scrolling: "yes",
              },
            }),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }